import { useMemo } from 'react';
import darkThemeData from './dark';
import lightThemeData from './light';
/**
 * Returns theme based on user preferences.
 *
 * @returns {Object} Current theme
 */
const useCurrentTheme = (themeValue) =>
  useMemo(
    () => (themeValue === 'dark-theme' ? darkThemeData : lightThemeData),
    [themeValue]
  );

export default useCurrentTheme;
